<template>
  <section id="email">
    <v-parallax dark src="@/assets/img/bgHero.jpg" height="200">
      <v-row justify="center" class="mt-16">
            <v-col cols="12" md="6" xl="8">
              <h3 class="display-1 font-weight-bold mb-4 " align="center">2FA Live Authentication</h3>
            </v-col>
      </v-row>
      <div class="svg-border-waves text-white">
        <v-img src="@/assets/img/borderWaves.svg" />
      </div>
    </v-parallax>
    <v-container>
      <v-row justify="center" class="d-block mx-auto mt-6" style="max-width: 1024px">
        <div>
          <h3>2FA Secret <span class="font-weight-regular">Get code for 2 factor authentication easiest</span></h3>
          <v-textarea
              placeholder="TITAN 2023..."
              outlined
              background-color="grey lighten-4"
              hide-details
              rows="5"
              class="mt-3"
              v-model="secret"
          >
          </v-textarea>
          <v-btn
              color="info"
              class="mt-4"
              @click="get2FaCode"
          >
            Submit
          </v-btn>
        </div>
        <div class="mt-6" ref="textInput">
          <h3>2FA Code <span class="font-weight-regular"> 2-step verification code </span></h3>
          <v-textarea
              placeholder="2FA Code"
              outlined
              background-color="white"
              hide-details
              rows="5"
              class="mt-3"
              v-model="result"
          >
          </v-textarea>
          <v-btn
              color="info"
              class="mt-4 mb-6"
              @click="copyToClipboard"
          >
            Copy
          </v-btn>
        </div>
      </v-row>
    </v-container>
  </section>
</template>

<script>

import {API_ENDPOINT, AUTH_TOKEN} from "@/constants";

export default {
  computed: {
    email_address() {
      return this.$store.getters.getEmailAddress
    },
    messages() {
      return this.$store.state.messages
    },
  },
  data: () => ({
    secret: "",
    result: ""
  }),
  methods: {
    async get2FaCode() {
      this.result = ""
      let code = "123456"
      try {
        const resp = await fetch(API_ENDPOINT + '/live2fa?text='+this.secret+'&token='+AUTH_TOKEN, {
          method: 'GET',
        })
        code = await resp.json()
      } catch (e) {
      }
      finally {
        this.result = code
      }
    },
    copyToClipboard() {
      const textarea = this.$refs.textInput.querySelector('textarea')
      textarea.focus()
      textarea.select()
      navigator.clipboard.writeText(this.result)
    }
  }
}
</script>

<style scoped>
section {
  position: relative;
}
.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

#email {
  z-index: 0;
}
.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
}

.card {
  min-height: 300px;
  padding: 10px;
  transition: 0.5s ease-out;
}

.card .v-image {
  margin-bottom: 15px;
  transition: 0.75s;
}

.card h1 {
  margin-bottom: 10px;
}

.zoom-efect {
  transform: scale(1.1);
}

.up {
  transform: translateY(-20px);
  transition: 0.5s ease-out;
}
</style>